import { Injectable } from '@angular/core';
import { CosmosDb } from 'lib/cosmos/cosmosDb.js';

@Injectable({
	providedIn: 'root'
})
export class LinkedItemsService {
	getOptionalItem<T extends CosmosDb.ICosmosItem>(
		id: string,
		linkedItems?: readonly CosmosDb.ICosmosItem[]
	): T | undefined {
		const item = linkedItems?.find((m) => m.id === id);

		if (!item) {
			return undefined;
		}

		return item as T;
	}
}
